import React, { useState, useEffect } from 'react';

export const SubModal = ({ isOpen, onClose, onSubmit, sub }) => {
	const [title, setTitle] = useState('');
	const [categories, setCategories] = useState([]);
	const [img, setImg] = useState();
	const [price, setPrice] = useState('');
	const [priceDisc, setPriceDisc] = useState('');


	useEffect(() => {
		if (sub) {
			setTitle(sub.title || '');
			setPrice(sub.price || '');
			setPriceDisc(sub.price_disc || '');
			const updatedCategories = sub.categories?.map((category) => ({
				name: category,
				1: sub.prices[category]?.[1] || '',
				3: sub.prices[category]?.[3] || '',
				12: sub.prices[category]?.[12] || '',
			})) || [];
			setCategories(updatedCategories);
			setImg(sub.img || '');
		}
	}, [sub]);

	const handleCategoryChange = (index, field, value) => {
		const updated = [...categories];
		updated[index] = {
			...updated[index],
			[field]: value,
		};
		setCategories(updated);
	};

	const handleAddCategory = () => {
		setCategories((prev) => [...prev, { name: '', 1: '', 3: '', 12: '' }]);
	};

	const handleSubmit = async () => {
		if (!title) {
			alert('Введите название подписки');
			return;
		}

		let prices = {};
		const categoryNames = [];

		categories.forEach((cat) => {
			if (cat.name) {
				categoryNames.push(cat.name);
				prices[cat.name] = {
					1: cat[1],
					3: cat[3],
					12: cat[12],
				};
			}
		});

		const formData = new FormData();
		formData.append('title', title);
		formData.append('price_disc', priceDisc || '');
		formData.append('categories', JSON.stringify(categoryNames));
		
		if (sub) formData.append('price', price || '');
		else formData.append('prices', JSON.stringify(prices));

		if (img) {
			formData.append('img', img);
		}

		// Главное изменение здесь
		onSubmit(formData);
	};

	if (!isOpen) return null;

	return (
		<div style={modalStyles}>
			<div style={modalContentStyles}>
				<input
					type="text"
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					placeholder="Название подписки"
					style={inputStyles}
				/>
				{
					sub &&
					<>
						<input
							type="text"
							value={price}
							onChange={(e) => setPrice(e.target.value)}
							placeholder="цена"
							style={inputStyles}
						/>

						<input
							type="text"
							value={priceDisc}
							onChange={(e) => setPriceDisc(e.target.value)}
							placeholder="цена со скидкой"
							style={inputStyles}
						/>
					</>
				}

				<input
					type="text"
					placeholder='ссылка на изображение'
					value={img}
					onChange={(e) => setImg(e.target.value)}
					style={inputStyles}
				/>

				{
					!sub &&
					<>
					<button onClick={handleAddCategory} style={{ ...buttonStyles, width: '100%', margin: '10px 0' }}>
						Добавить категорию
					</button>

				{categories.map((cat, index) => (
						<div key={index} style={{ marginBottom: '15px', border: '1px solid #eee', padding: '10px', borderRadius: '5px' }}>
							<input
								type="text"
								value={cat.name}
								onChange={(e) => handleCategoryChange(index, 'name', e.target.value)}
								placeholder="Название категории"
								style={inputStyles}
							/>
							{[1, 3, 12].map((months) => (
								<input
									key={months}
									type="number"
									value={cat[months] || ''}
									onChange={(e) => handleCategoryChange(index, months, e.target.value)}
									placeholder={`Цена за ${months} мес.`}
									style={inputStyles}
								/>
							))}
						</div>
					))}
					</>
				}
				
				<div style={buttonContainerStyles}>
					<button onClick={handleSubmit} style={buttonStyles}>
						{sub ? 'Обновить' : 'Добавить'}
					</button>
					<button onClick={onClose} style={buttonStyles}>
						Закрыть
					</button>
				</div>
			</div>
		</div>
	);
};

// Стили
const modalStyles = {
	position: 'fixed',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: 1000,
};

const modalContentStyles = {
	backgroundColor: 'white',
	padding: '20px',
	borderRadius: '8px',
	width: '400px',
	maxHeight: '90%',
	overflowY: 'auto',
	textAlign: 'center',
};

const inputStyles = {
	width: '100%',
	padding: '10px',
	margin: '5px 0',
	borderRadius: '5px',
	border: '1px solid #ccc',
};

const buttonContainerStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	marginTop: '10px',
};

const buttonStyles = {
	padding: '10px',
	borderRadius: '5px',
	border: '1px solid #ccc',
	cursor: 'pointer',
};
